{
    "ChartstyleoptionsPie2d": "Taart (2D)",
    "ChartstyleoptionsPie3d": "Taart (3D)",
    "ChartstyleoptionsDoughnut2d": "Donut (2D)",
    "ChartstyleoptionsDoughnut3d": "Donut (3D)",
    "ChartstyleoptionsLine": "Lijn",
    "ChartstyleoptionsArea": "Gebied",
    "ChartstyleoptionsAreastacked": "Gebied (gestapeld)",
    "ChartstyleoptionsRadarpolararea": "Radar (polair gebied)",
    "ChartstyleoptionsColumn2d": "Kolom (2D)",
    "ChartstyleoptionsColumn2dstacked": "Kolom (2D, gestapeld)",
    "ChartstyleoptionsColumn3d": "Kolom (3D)",
    "ChartstyleoptionsColumn3dstacked": "Kolom (3D, Gestapeld)",
    "ChartstyleoptionsBar2d": "Staaf (2D)",
    "ChartstyleoptionsBar2dstacked": "Staaf (2D, Gestapeld)",
    "ChartstyleoptionsBar3d": "Staaf (3D)",
    "ChartstyleoptionsBar3dstacked": "Staaf (3D, Gestapeld)",
    "NAME": "ChartStyleOptions"
}